import AbandonedCallsModule from './UrgentFollowUpsModule/AbandonedCallsModule';
import AuthModule from './AuthModule';
import BrowserNotificationsModule from './BrowserNotificationsModule';
import DiagnosticsModule from './DiagnosticsModule';
import E911AddressModule from './E911AddressModule';
import FeatureFlagModule from './FeatureFlagModule';
import FullStoryModule from './FullStoryModule';
import InboxModule from './InboxModule';
import InteractionsModule from './InteractionsModule';
import LogEnvVars from './LogEnvModule';
import SentryModule from './SentryModule';
import ServiceModule from './ServiceModule';
import SoftPhoneModule from './SoftPhoneModule';
import TasksModule from './TasksModule';
import ToastModule from './ToastModule';
import UserStatusModule from './UserStatusModule';

const modules = [
  DiagnosticsModule,
  SentryModule,
  LogEnvVars,
  FeatureFlagModule,
  FullStoryModule,
  ServiceModule,
  TasksModule,
  SoftPhoneModule,
  InteractionsModule,
  UserStatusModule,
  InboxModule,
  ToastModule,
  BrowserNotificationsModule,
  AbandonedCallsModule,
  E911AddressModule,
  AuthModule, // keep this last
];
export default modules;
